var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeButtonActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Page-1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.827,
    height: 27.903,
    viewBox: "0 0 32.827 27.903",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Core",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M13.131,27.9V18.055H19.7V27.9H27.9V14.772h4.924L16.414,0,0,14.772H4.924V27.9Z",
    fill: "#6767E0",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeButtonActive);
export default __webpack_public_path__ + "static/media/home-button-active.50455282911e405bbad033fd49d49e63.svg";
export { ForwardRef as ReactComponent };